import { StringUtil } from '@nomidio/common';

export class AccessGroupRule {
  public id: string;
  public type: RuleType;
  public value: string;

  constructor(backendGroupRule?: BackendAccessGroupRule) {
    if (backendGroupRule) {
      this.id = backendGroupRule.id;
      this.type = backendGroupRule.type;
      this.value = backendGroupRule.value;
    }
  }

  public toBackend(): BackendAccessGroupRule {
    return {
      id: this.id,
      type: this.type,
      value: this.value,
    };
  }
}

export interface BackendAccessGroupRule {
  id: string;
  type: RuleType;
  value: string;
}

export enum RuleType {
  Email = 'EMAIL',
  Domain = 'DOMAIN',
  Group = 'GROUP',
  Exclusion = 'EXCLUSION',
}

export function RuleTypePresentation(ruleType: RuleType): string {
  switch (ruleType) {
    case RuleType.Email:
    case RuleType.Domain:
    case RuleType.Group:
    case RuleType.Exclusion:
      return StringUtil.toPresentationFormat(ruleType);
    default:
      console.warn(`Unrecognised access group '${ruleType}' requested for presentation`);
      return StringUtil.toPresentationFormat(ruleType);
  }
}
